import { render, staticRenderFns } from "./EndorsementTypeModal.vue?vue&type=template&id=0cd385a8&scoped=true"
import script from "./EndorsementTypeModal.vue?vue&type=script&lang=js"
export * from "./EndorsementTypeModal.vue?vue&type=script&lang=js"
import style0 from "./EndorsementTypeModal.vue?vue&type=style&index=0&id=0cd385a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd385a8",
  null
  
)

export default component.exports